export const AutomationModalPaneOptions = {
  CREATE: 'create',
  EDIT: 'edit',
  LIST: 'list',
} as const;
